import { render } from "./upload-documents.vue?vue&type=template&id=6bc5e97a"
import script from "./upload-documents.vue?vue&type=script&lang=js"
export * from "./upload-documents.vue?vue&type=script&lang=js"
script.render = render

export default script